"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.entries = exports.flatMap = exports.clone = exports.mixin = exports.getEventSubscriptions = exports.merge = exports.hasOwnProperty = exports.toTitleCase = exports.randomText = exports.randomInt = exports.isType = exports.getDefaultValue = exports.isNumber = exports.getConstructorName = exports.getTypeName = exports.parseFunctionName = exports.replaceTokens = exports.evalPath = exports.navigateAttribute = exports.ensureNamespace = exports.getGlobalObject = void 0;
function getGlobalObject() {
    if (typeof window === "object" && Object.prototype.toString.call(window) === "[object Window]") {
        return window;
    }
    else if (typeof global === "object") {
        return global;
    }
    else {
        return null;
    }
}
exports.getGlobalObject = getGlobalObject;
function ensureNamespace(name, parentNamespace) {
    var result;
    var nsTokens;
    var target = parentNamespace;
    if (typeof target === "string") {
        nsTokens = target.split(".");
        target = getGlobalObject();
        nsTokens.forEach(function (token) {
            target = target[token];
            if (target === undefined) {
                throw new Error("Parent namespace \"" + parentNamespace + "\" could not be found.");
            }
        });
    }
    else if (target === undefined || target === null) {
        target = getGlobalObject();
    }
    // create the namespace object if it doesn't exist, otherwise return the existing namespace
    if (!(name in target)) {
        result = target[name] = {};
        return result;
    }
    else {
        return target[name];
    }
}
exports.ensureNamespace = ensureNamespace;
function navigateAttribute(obj, attr, callback, thisPtr) {
    if (thisPtr === void 0) { thisPtr = null; }
    for (var val = obj[attr]; val != null; val = val[attr]) {
        if (callback.call(thisPtr || obj, val) === false) {
            return;
        }
    }
}
exports.navigateAttribute = navigateAttribute;
function isObject(obj) {
    return getTypeName(obj) === "object" || (obj && obj instanceof Object);
}
// If a getter method matching the given property name is found on the target it is invoked and returns the
// value, unless the the value is undefined, in which case null is returned instead.  This is done so that
// calling code can interpret a return value of undefined to mean that the property it requested does not exist.
function getValue(target, property) {
    var value;
    // the see if there is an explicit getter function for the property
    var getter = target["get_" + property];
    if (getter) {
        value = getter.call(target);
        if (value === undefined) {
            value = null;
        }
    }
    // otherwise search for the property
    else {
        if ((isObject(target) && property in target) ||
            Object.prototype.hasOwnProperty.call(target, property) ||
            (target.constructor === String && /^[0-9]+$/.test(property) && parseInt(property, 10) < target.length)) {
            value = target[property];
            if (value === undefined) {
                value = null;
            }
        }
        else if (/\./.test(property)) {
            // TODO: Warn about passing multi-hop path to `getValue()`
            // logWarning("Possible incorrect usage of \"getValue()\", the path \"" + property + "\" does not exist on the target and appears to represent a multi-hop path.");
        }
    }
    return value;
}
function evalPath(obj, path, nullValue, undefinedValue) {
    if (nullValue === void 0) { nullValue = null; }
    if (undefinedValue === void 0) { undefinedValue = undefined; }
    var value = obj;
    var steps = path.split(".");
    for (var i = 0; i < steps.length; ++i) {
        var name_1 = steps[i];
        var source = value;
        value = getValue(source, name_1);
        if (value === null) {
            return nullValue;
        }
        if (value === undefined) {
            return undefinedValue;
        }
    }
    return value;
}
exports.evalPath = evalPath;
/**
 * Replace tokens (ex: {0}) in the given string
 * @param template The template string
 * @param params The replacement parameters
 */
function replaceTokens(template, params) {
    if (params) {
        return template.replace(/{([^}]+)}/g, function (match, key) {
            return hasOwnProperty(params, key) ? params[key] : match;
        });
    }
    return template;
}
exports.replaceTokens = replaceTokens;
var fnRegex = /function\s*([\w_$]*)/i;
function parseFunctionName(fn) {
    var fnMatch = fnRegex.exec(fn.toString());
    return fnMatch ? (fnMatch[1] || "{anonymous}") : "{anonymous}";
}
exports.parseFunctionName = parseFunctionName;
var typeNameExpr = /\s([a-z|A-Z]+)/;
function getTypeName(obj) {
    if (obj === undefined)
        return "undefined";
    if (obj === null)
        return "null";
    return Object.prototype.toString.call(obj).match(typeNameExpr)[1].toLowerCase();
}
exports.getTypeName = getTypeName;
function getConstructorName(ctor) {
    // Handle value types explicitly
    if (ctor === String)
        return "String";
    if (ctor === Number)
        return "Number";
    if (ctor === Date)
        return "Date";
    if (ctor === Boolean)
        return "Boolean";
    // Try to use function name
    if (typeof ctor === "function" && ctor.name) {
        return ctor.name;
    }
    // Fall back to the low-level 'toString' on the prototype
    return getTypeName(ctor.prototype);
}
exports.getConstructorName = getConstructorName;
function isNumber(obj) {
    return getTypeName(obj) === "number" && !isNaN(obj);
}
exports.isNumber = isNumber;
function getDefaultValue(isList, jstype) {
    if (isList)
        return [];
    if (jstype === Boolean)
        return false;
    if (jstype === Number)
        return 0;
    return null;
}
exports.getDefaultValue = getDefaultValue;
function isType(obj, test) {
    if (test === void 0) { test = null; }
    if (test) {
        return test(obj);
    }
    else {
        // Do nothing, assume object is of the type
        return true;
    }
}
exports.isType = isType;
function randomInt(min, max) {
    if (min === void 0) { min = 0; }
    if (max === void 0) { max = 9; }
    var rand = Math.random();
    return rand === 1 ? max : Math.floor(rand * (max - min + 1)) + min;
}
exports.randomInt = randomInt;
function randomText(len, includeLetters, includeDigits) {
    if (includeLetters === void 0) { includeLetters = true; }
    if (includeDigits === void 0) { includeDigits = true; }
    if (!includeLetters && !includeDigits) {
        return;
    }
    var result = "";
    for (var i = 0; i < len; i++) {
        var min = includeLetters ? 0 : 26;
        var max = includeDigits ? 35 : 25;
        var rand = randomInt(min, max);
        var charCode;
        if (rand <= 25) {
            // Alpha: add 97 for 'a'
            charCode = rand + 97;
        }
        else {
            // Num: start at 0 and add 48 for 0
            charCode = (rand - 26) + 48;
        }
        result += String.fromCharCode(charCode);
    }
    return result;
}
exports.randomText = randomText;
function toTitleCase(input) {
    // https://stackoverflow.com/questions/196972/convert-string-to-title-case-with-javascript/6475125#6475125
    var i, j, str, lowers, uppers;
    str = input.replace(/([^\W_]+[^\s-]*) */g, function (txt) {
        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    });
    // Certain minor words should be left lowercase unless
    // they are the first or last words in the string
    lowers = ["A", "An", "The", "And", "But", "Or", "For", "Nor", "As", "At",
        "By", "For", "From", "In", "Into", "Near", "Of", "On", "Onto",
        "To", "With"];
    for (i = 0, j = lowers.length; i < j; i++) {
        str = str.replace(new RegExp("\\s" + lowers[i] + "\\s", "g"), function (txt) {
            return txt.toLowerCase();
        });
    }
    // Certain words such as initialisms or acronyms should be left uppercase
    uppers = ["Id", "Tv"];
    for (i = 0, j = uppers.length; i < j; i++) {
        str = str.replace(new RegExp("\\b" + uppers[i] + "\\b", "g"), uppers[i].toUpperCase());
    }
    return str;
}
exports.toTitleCase = toTitleCase;
function hasOwnProperty(obj, prop) {
    return Object.prototype.hasOwnProperty.call(obj, prop);
}
exports.hasOwnProperty = hasOwnProperty;
function merge(obj1) {
    var objs = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        objs[_i - 1] = arguments[_i];
    }
    var target = {};
    for (var arg in obj1) {
        if (hasOwnProperty(obj1, arg)) {
            target[arg] = obj1[arg];
        }
    }
    for (var i = 0; i < objs.length; i++) {
        var obj = objs[i];
        for (var arg in obj) {
            if (hasOwnProperty(obj, arg)) {
                target[arg] = obj[arg];
            }
        }
    }
    return target;
}
exports.merge = merge;
function getEventSubscriptions(event) {
    var func = event.func;
    if (func) {
        var funcs = func._funcs;
        if (funcs.length > 0) {
            var subs = funcs.map(function (f) { return { handler: f.fn, isExecuted: f.applied, isOnce: f.once }; });
            return subs;
        }
        else {
            return null;
        }
    }
}
exports.getEventSubscriptions = getEventSubscriptions;
function mixin(ctor, methods) {
    for (var key in methods) {
        if (hasOwnProperty(methods, key) && methods[key] instanceof Function) {
            ctor.prototype[key] = methods[key];
        }
    }
}
exports.mixin = mixin;
/**
 * Recursively clone an object and its children
 * @param value The object to clone
 */
function clone(obj) {
    var result = {};
    for (var prop in obj) {
        if (hasOwnProperty(obj, prop)) {
            var value = obj[prop];
            result[prop] = value instanceof Array ? (value.length === 1 ? [value[0]] : Array.apply(null, value)) : typeof value === "object" ? clone(value) : value;
        }
    }
    return result;
}
exports.clone = clone;
/**
 * Helper alternative to Array.prototype.flatMap
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/flatMap#Alternative
 * @param input The input array
 * @param callback A function that returns an array of outputs for each input
 */
function flatMap(input, callback) {
    return input.reduce(function (arr, i) { return arr.concat(callback(i)); }, []);
}
exports.flatMap = flatMap;
/**
 * Helper alternative to Object.entries
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/entries#Polyfill
 * @param input The input array
 */
function entries(obj) {
    // eslint-disable-next-line one-var
    var ownProps = Object.keys(obj), i = ownProps.length, resArray = new Array(i); // preallocate the Array
    while (i--)
        resArray[i] = [ownProps[i], obj[ownProps[i]]];
    return resArray;
}
exports.entries = entries;
